"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
exports.intervalSelect = function (selected, data, field, rowIndex) {
    if (selected.length === 0) {
        throw new Error('Selected list must contains at least 1 element');
    }
    if (selected.length === 1) {
        var selectedIndex_1 = data.findIndex(function (row) { return row[field] === selected[0][field]; });
        var filteredData = data.filter(function (row, idx) {
            return idx >= Math.min(rowIndex, selectedIndex_1) && idx <= Math.max(rowIndex, selectedIndex_1);
        });
        return rowIndex < selectedIndex_1 ? filteredData.reverse() : filteredData;
    }
    var headIndex = data.findIndex(function (item) { return item[field] === selected[0][field]; });
    if (rowIndex < headIndex) {
        return data.filter(function (item, index) { return index >= rowIndex && index <= headIndex; }).reverse();
    }
    return data.filter(function (item, index) { return index >= headIndex && index <= rowIndex; });
};
var toggleItem = function (contains, selected, rowData, field) {
    if (contains) {
        return selected.filter(function (item) { return item[field] !== rowData[field]; });
    }
    return selected.concat(rowData);
};
var updateSelected = function (_a) {
    var selection = _a.selection, rowData = _a.rowData, rowClick = _a.rowClick, keyboard = _a.keyboard, data = _a.data, isRowDisabled = _a.isRowDisabled, isContextClick = _a.isContextClick;
    if (!selection) {
        return [];
    }
    var multiple = selection.multiple, field = selection.field, selected = selection.selected;
    var contains = !!selected.find(function (row) { return row[field] === rowData[field]; });
    var rowIndex = data.findIndex(function (row) { return row[field] === rowData[field]; });
    if (multiple) {
        if (keyboard.shift) {
            if (selected.length) {
                return exports.intervalSelect(selected, data, field, rowIndex).filter(function (selectedRowData) {
                    return !(isRowDisabled === null || isRowDisabled === void 0 ? void 0 : isRowDisabled({
                        rowData: selectedRowData,
                        rowIndex: data.findIndex(function (rowData) { return fast_deep_equal_1.default(rowData, selectedRowData); })
                    }));
                });
            }
            return toggleItem(contains, selected, rowData, field);
        }
        // In Windows click on row deselect rest items, but click with pressed control key toggle this item.
        if (rowClick) {
            if (isContextClick && !contains) {
                return toggleItem(contains, selected, rowData, field);
            }
            if (isContextClick) {
                return selected;
            }
            if (keyboard.ctrl || keyboard.meta) {
                return toggleItem(contains, selected, rowData, field);
            }
            return [rowData];
        }
        else {
            return toggleItem(contains, selected, rowData, field);
        }
    }
    else {
        // We need to check the click on the line, because we must have a behavior like in Windows.
        // In Windows click on row only select item, and a click on checkbox toggle item.
        if (rowClick) {
            return [rowData];
        }
        return contains ? [] : [rowData];
    }
};
exports.default = updateSelected;
//# sourceMappingURL=updateSelected.js.map